export const LaneTypes = [
    'manualpolygon',
    'bus',
    'left',
    'left', // intentional duplicate, cause thats how device reports numbers of active lanes
    'ego',
    'right',
    'rightheuristic',
    'right2',
    'absolute0',
    'absolute1',
    'absolute2',
    'absolute3',
    'busstop',
    'bike',
    'opp_heur_0',
    'opp_heur_1',
    'opp_left',
    'opp_bus',
    'opp_bike'
];

// laneTypeLabels overrides the default humanizeEnum() display for lane types
// whose UI label can't be derived from their metadata key.
export const laneTypeLabels: Partial<Record<string, string>> = {
    opp_heur_0: 'OppHeuristic0',
    opp_heur_1: 'OppHeuristic1',
    opp_left: 'OppLeft',
    opp_bus: 'OppBus',
    opp_bike: 'OppBike'
};
